//请自行添加语言资源
const bill = {
  rebateAmount:'返利金额',
  billMonth:'年月',
  paymentAmount:'付款金额',
  salesAmount:'销售金额',
  endingBalance:'期末余额',
  beginningBalance:'期初余额',
  confirmStatus:'确认状态',
  priceDueDate:'净价到期日',
  reference:'参照',
  currencyType:'货币类型',
  sapNo:'SAP订单编号',
  salesVoucherType:'SAP订单类型',
  postDate:'记账日期',
  orderAmount:'订单金额',
  goldenTaxDate:'金税日期',
  goldenTaxNumber:'金税号',
  billRange:'范围',
  financialVoucherNo:'财务凭证号',
  type:'Type',
  textData:'文本',
  customerNo: '客户编号',
  customerName: '客户名称',
  reasonCode:'原因代码',
  reasonCodeDesc:'原因代码描述',
  msg:{
  }
};
export default bill



// WEBPACK FOOTER //
// ./src/page/finance/bill/lang/bill.zh.js